import { Link } from 'react-router-dom';
import { Eye, Heart, ChatCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { ListingStatusBadge } from '../ListingStatusBadge';
import { getCategoryName } from '../../utils/categoryNames';
import { ListingCardActions } from './ListingCardActions';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ListingCardGrid = ({ listing, price, stats, onDeleteClick, onRestore, onRenew, onPromote }) => {
  const { t } = useTranslation();
  const isDeleted = listing.status === 'deleted';
  return (
    <div className={`bg-white border border-border rounded-xl overflow-hidden ${isDeleted ? 'opacity-60' : ''}`} data-testid={`my-listing-card-${listing.listing_id}`}>
      <Link to={`/listings/${listing.listing_id}`} className={isDeleted ? 'pointer-events-none' : ''}>
        <div className="aspect-[4/3] bg-surface relative">
          {listing.images?.length > 0 ? (
            <img src={`${API}/files/${listing.images[0]}`} alt={listing.title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-text_muted text-sm">{t('common.noImage')}</div>
          )}
          <div className="absolute top-2 left-2">
            <ListingStatusBadge listing={listing} showActive />
          </div>
        </div>
      </Link>
      <div className="p-3">
        <Link to={`/listings/${listing.listing_id}`} className={isDeleted ? 'pointer-events-none' : ''}>
          <h3 className="font-semibold font-heading text-sm line-clamp-1 hover:text-primary" data-testid="listing-title">{listing.title}</h3>
        </Link>
        <p className="text-xs text-text_muted mb-1 line-clamp-1">{getCategoryName(listing.category, t)}</p>
        <p className="text-base font-bold text-primary mb-2" data-testid="listing-price">{price}</p>
        <div className="flex items-center gap-3 text-[11px] text-text_muted mb-3">
          <span className="flex items-center gap-1"><Eye size={12} /> {listing.view_count || 0}</span>
          <span className="flex items-center gap-1"><Heart size={12} /> {stats.favorites_count || 0}</span>
          <span className="flex items-center gap-1"><ChatCircle size={12} /> {stats.messages_count || 0}</span>
        </div>
        <ListingCardActions listing={listing} onDeleteClick={onDeleteClick} onRestore={onRestore} onRenew={onRenew} onPromote={onPromote} />
      </div>
    </div>
  );
};
